import React from "react"
import styles from "./TextArea.module.css"
import Label from "./Label"
import RequiredNotice from "./RequiredNotice"
import { ERRORS } from "./constants"

const TextArea = (props) => {
  const { id, label, characterLimit, onChange, value, required, error, className, testId } = props
  const updateText = (event) => {
    const newText = event.target.value
    if (newText.length < characterLimit || !characterLimit) {
      onChange(newText)
    } else {
      onChange(newText.slice(0, characterLimit))
    }
  }

  return (
    <div className={`${styles.container} ${className}`} data-testid={testId || "textarea-component"}>
      <Label id={id} required={required} hasError={Boolean(error)}>
        {label}
      </Label>
      <textarea
        id={id}
        data-testid="textarea"
        value={value}
        className={`${styles.textarea} ${error ? styles.error : ""}`}
        onChange={updateText}
      />
      <div className={styles.footer}>
        <RequiredNotice required={required} hasError={error === ERRORS.required} />
        {characterLimit && (
          <span
            className={`${styles.characterLimit} ${value.length === characterLimit ? styles.characterLimitError : ""}`}
            data-testid="character-limit"
          >
            {`${value.length}/${characterLimit}`}
          </span>
        )}
      </div>
    </div>
  )
}

TextArea.defaultProps = {
  value: "",
  error: "",
  onChange: () => {},
  className: "",
}

export default TextArea
